module.exports = __webpack_public_path__ + "img/404-page.d9af3f4.png";